const TRANSLATE: { [key: string]: string }= {
    "index.search.text": "Ingresá el número de tu pedido o código de consultora en el buscador y descubrí el estado de tus pedidos.",
    "index.search.placeholder": "Ingresar número de pedido o consultora sin puntos",
    "order.stop.event.title": "Lamentablemente tuvimos un inconveniente con su pedido.",
    "order.stop.event.replacement": "A continuación generaremos un nuevo pedido y en breve podrá consultar el número en la Web o App Mi Negocio.",
    "order.stop.event.thanks": "Les pedimos disculpas por el inconveniente. <br /> Saludos.",
    "order.data.pathEntregaFallida": "Entrega Fallida",
    "order.data.pathRemito": "Remito",
    "order.notfound.message": "¡En este momento tu pedido {id} no tiene ninguna novedad!",
    "global.chat.title": "¿Necesitas ayuda? Aquí estamos",
    "global.chat.subtitle": "Hola, te puedo ayudar con las dudas que tengas, escribime!",
    "timeline.builder.default.0": "En almacén Natura",
    "timeline.builder.default.1": "En almacén transportista",
    "timeline.builder.default.2": "En reparto",
    "timeline.builder.default.3": "Entrega"
}

export default TRANSLATE
